import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Breadcrumbs = styled.div`
	display: flex;
	align-items: center;
	font-weight: 500;
	margin-top: 7px;
	margin-left: 10px;
	font-size: 12px;
	letter-spacing: 0.3px;
	color: ${colors.grey6};
	span {
		cursor: pointer;
		font-size: 12px;
	}

	span:hover {
		cursor: pointer;
		color: ${colors.grey9};
	}
`;
export const Container = styled.div`
	display: flex;
`;

export const ContentDiv = styled.div`
	height: 86%;
	overflow: auto;
`;
